// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-button__text.hidden-mob[data-v-0f14fd62]{display:none}@media(min-width:768px){.filter-button__text.hidden-mob[data-v-0f14fd62]{display:inherit}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
